module.exports = __webpack_public_path__ + "img/EJ Dash grey.18811bab.png";